import { useState, useMemo, useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { documentwhite, whitedelete, whiteplay } from "../utils/svgs/svgcode";
import { externalapi } from "../api/externalapi";
import dayjs from "dayjs";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { drag, menu, OutlinePauseIcon, OutlinePlayIcon } from "./svg";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VoiceMailViewModal from "./modals/voicemailview";
const VoiceMailTable = ({ loading, voicemails, fetchVoicemail }) => {
  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
const [isMuted, setIsMuted] = useState(false);
const [openMenuId, setOpenMenuId] = useState(null);
const menuRef = useRef(null);

// for view modal
const [viewModalOpen, setViewModalOpen] = useState(false);

  // Selection / detail
  const [isLoading, setIsLoading] = useState(false);
  const [selectedVoicemailId, setSelectedVoicemailId] = useState(null);
  const [selectedVoicemail, setSelectedVoicemail] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [iscollapse,setIsCollapse]=useState(!false)
  console.log("selectedVoicemail",selectedVoicemail);
  
  // Audio state
  const [audioUrl, setAudioUrl] = useState(null);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0); // seconds
  const [currentTime, setCurrentTime] = useState(0); // seconds
  const progressPct = duration ? (currentTime / duration) * 100 : 0;

  const totalPages = Math.ceil((voicemails?.length || 0) / itemsPerPage);
  const paginatedData = useMemo(
    () =>
      voicemails?.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ) || [],
    [voicemails, currentPage, itemsPerPage]
  );

  const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage((p) => p + 1);
  const handlePerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
useEffect(() => {
  function handleClickOutside(e) {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setOpenMenuId(null);
    }
  }

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  const selectVoicemail = (voicemailItem) => {
    setSelectedVoicemailId(voicemailItem.id);
    setSelectedVoicemail(voicemailItem);
    viewaudio(voicemailItem);
  };

  const viewaudio = async (item) => {
    const obj = {
      extensionid: item.extensionId,
      attachmentid: item.attachments?.[0]?.id,
      messageid: item.id,
      type: "txt",
    };
    if (!obj.attachmentid) return;

    setIsLoading(true);
    try {
      const response = await externalapi.post("/ringcentral/voice/getvm/", obj);
      if (response?.data?.result === "true" && response?.data?.documenturl) {
        setAudioUrl(response.data.documenturl);
      } else {
        setAudioUrl(null);
      }
    } catch (error) {
      console.error("Error fetching voicemail audio:", error);
      setAudioUrl(null);
    } finally {
      setIsLoading(false);
    }
  };

  const openDeleteModal = (item) => {
    setSelectedVoicemail(item);
    setDeleteModalOpen(true);
  };
  const closeDeleteModal = () => {
    setDeleteModalOpen(false);

  };

  const handleDelete = async () => {
    if (!selectedVoicemail) return;
    const obj = {
      extensionid: selectedVoicemail.extensionId,
      messageid: selectedVoicemail.id,
    };
    setIsLoading(true);
    try {
      await externalapi.post("/ringcentral/voice/delete/", obj);
      fetchVoicemail(true);
      setSelectedVoicemailId(null);
      setSelectedVoicemail(null);
      setAudioUrl(null);
    } catch (error) {
      console.error("Error deleting voicemail:", error);
    } finally {
      setIsLoading(false);
      closeDeleteModal();
    }
  };

  useEffect(() => {
    if (voicemails?.length) setCurrentPage(1);
  }, [voicemails?.length]);

  // Time helpers
  const formatTime = (sec) => {
    if (!isFinite(sec)) return "0:00";
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  };

  // When audioUrl changes, reset player
  useEffect(() => {
    setIsPlaying(false);
    setDuration(0);
    setCurrentTime(0);
    const a = audioRef.current;
    if (a) {
      a.pause();
      // force reload the new src
      a.load?.();
    }
  }, [audioUrl]);

  // Audio DOM event handlers
  const onLoadedMetadata = () => {
    const a = audioRef.current;
    if (!a) return;
    setDuration(a.duration || 0);
  };

  const onTimeUpdate = () => {
    const a = audioRef.current;
    if (!a) return;
    setCurrentTime(a.currentTime || 0);
  };

  const onEnded = () => {
    setIsPlaying(false);
  };

  const togglePlay = () => {
    const a = audioRef.current;
    if (!a) return;
    if (isPlaying) {
      a.pause();
    } else {
      a.play().catch((e) => console.warn("Playback failed:", e));
    }
  };

  const seekToClick = (e) => {
    if (!duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const pct = Math.min(Math.max(x / rect.width, 0), 1);
    const a = audioRef.current;
    if (!a) return;
    a.currentTime = pct * duration;
  };

  // Safe date formatting
  const formatDate = (date) => {
    try {
      if (!date) return "N/A";
      const d = dayjs(date);
      if (!d.isValid()) return "Invalid Date";
      return d.format("MM-DD-YYYY, hh:mm A");
    } catch {
      return "Error";
    }
  };

  return (
    <div className="w-full rounded-[20px] bg-[#FFF] p-2">
      {/* Master–Detail */}
      <div>
  <div className="w-full border-b border-[#E5E7EB] flex justify-between items-center mb-4 text-start p-2 px-3 pb-4 ">
           
              <div className="text-[14px] font-normal font-inter text-[#232323]">
                Play Voicemail
              </div>
             <div
  className="cursor-pointer"
  onClick={() => setIsCollapse(!iscollapse)}
>
  {drag(iscollapse ? "green" : "#e17954")}
</div>

          </div>

      <div className="w-full flex gap-1 min-h-[60vh] custom-scrollbar max-h-[82vh]">
     
        <div className={`w-full ${iscollapse?"sm:w-[18%]":"sm:w-[38%]"} flex flex-col`}>
          {!iscollapse &&<div className="flex items-center justify-between px-2 py-2 text-sm text-[#667085]">
            <div>Total: {voicemails?.length || 0}</div>
            <div className="flex items-center gap-2">
              <span>Per Page:</span>
              <select
                value={itemsPerPage}
                onChange={handlePerPageChange}
                className="border rounded-md px-2 py-1 text-[#1d2951]"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
              </select>
            </div>
          </div> }

          <div className="flex-1 min-h-0 overflow-y-auto pr-1">
            {loading ? (
              <div className="w-full py-10 text-center text-gray-500">
                Loading...
              </div>
            ) : paginatedData.length === 0 ? (
              <div className="w-full py-10 text-center text-gray-500">
                No Data Available
              </div>
            ) : (
              <ul className="space-y-3">
                {paginatedData.map((voicemailItem, idx) => {
                  const isActive = selectedVoicemailId === voicemailItem.id;
                  return (
                    <li
                      key={voicemailItem.id}
                      className={`rounded-[10px] text-start border border-[#E5E7EB] hover:bg-[#F8FAFC] transition-all cursor-pointer ${
                        isActive
                          ? "!bg-[#50869A] text-white shadow-md"
                          : "bg-white"
                      }`}
                      onClick={() => selectVoicemail(voicemailItem)}
                    >
                      <div className="flex items-start gap-4 p-2">
                        <div
                          className={`flex text-sm  font-medium font-inter ${
                            isActive ? "text-white" : "text-black"
                          }`}
                        >
                          {(currentPage - 1) * itemsPerPage + idx + 1}
                        </div>

                        <div className="flex-1  w-full">
                          <div className="flex flex-col items-start justify-start gap-1">
                            <div
                              className={`max-w-[99%]  font-medium font-inter text-xs ${
                                isActive ? "text-[#FFFFFF]" : "text-[#232323]"
                              }`}
                            >
                              {voicemailItem?.from?.name || "Unknown"}
                            </div>
                            <div className="flex justify-between w-full">
 <div
                              className={`truncate  font-inter text-[10px] font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              {voicemailItem?.from?.phoneNumber || "N/A"}
                            </div>
{iscollapse && (
  <div className="relative">
    {/* 3 clickable dots */}
    <div
      className="flex items-center gap-[3px] cursor-pointer"
      onClick={(e) => {
        e.stopPropagation();
        setOpenMenuId(openMenuId === voicemailItem.id ? null : voicemailItem.id);
      }}
    >
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
      <div className={`w-[6px] h-[6px] ${isActive ? 'bg-white' : 'bg-[#7E7E7E]'} rounded-full`} />
    </div>
{openMenuId === voicemailItem.id && (
  <div
    ref={menuRef}
    className="absolute right-0 top-5 bg-white border shadow-md rounded-md text-xs z-50 w-[100px]"
    onClick={(e) => e.stopPropagation()}
  >
    <div
      className="px-3 py-2 text-[#232323] hover:bg-gray-100 cursor-pointer"
      onClick={() => {
        setSelectedVoicemail(voicemailItem);
        setViewModalOpen(true);
        setOpenMenuId(null);
      }}
    >
      View
    </div>

    <div
      className="px-3 py-2 text-red-600 hover:bg-gray-100 cursor-pointer"
      onClick={() => {
        openDeleteModal(voicemailItem);
        setOpenMenuId(null);
      }}
    >
      Delete
    </div>
  </div>
)}

  </div>
)}


  
                            </div>
                           
                            {/* <div
                              className={`text-[10px] font-inter font-normal ${
                                isActive ? "text-[#FFFFFFCC]" : "text-[#7E7E7E]"
                              }`}
                            >
                              {formatDate(voicemailItem.creationTime)}
                            </div> */}
                          </div>
                        </div>

                        <div className="flex items-center gap-3">
                          {/* <div className={`px-2 py-[3px] rounded-full text-[10px] font-inter font-medium ${!!isActive ? "bg-[#FFFFFF1A] text-white border border-white/40" : "bg-[#F0FDF4] text-[#22C55E] border-[1px] border-[#22C55E]"}`}>
{voicemailItem?.readStatus}
                          </div> */}
                          {/* <PlayArrowIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white" : "text-[#6B7280]"
                            } cursor-pointer`}
                            onClick={(e) => {
                              e.stopPropagation();
                              selectVoicemail(voicemailItem);
                            }}
                          /> */}
                          {/* <VisibilityIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white/80" : "text-[#9CA3AF]"
                            } cursor-pointer`}
                            onClick={(e) => {
                              e.stopPropagation();
                              selectVoicemail(voicemailItem);
                            }}
                          /> */}
                          {!iscollapse&&<DeleteOutlineIcon
                            fontSize="small"
                            className={`${
                              isActive ? "text-white/80" : "text-[#9CA3AF]"
                            } cursor-pointer`}
                            onClick={(e) => {
                              e.stopPropagation();
                              openDeleteModal(voicemailItem);
                            }}
                          />}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            )}
          </div>

          {/* Pagination footer */}
         {voicemails?.length > 0 && (
  <>
    <div className="flex flex-col items-start gap-1">

      {/* Page Info */}
   

      {/* Total + Per Page */}
      {iscollapse&&<div className="flex items-center justify-between w-full px-2 py-1 text-sm text-[#667085]">
        {/* <div>Total: {voicemails?.length || 0}</div> */}

        <div className="flex items-center gap-2">
          <span>Per Page:</span>
          <select
            value={itemsPerPage}
            onChange={handlePerPageChange}
            className="border rounded-md px-2 py-[2px] text-[#1d2951] text-sm"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </select>
        </div>
      </div>}

      {/* Pagination Buttons */}
      <div className="flex items-center gap-2 justify-between w-full mt-2 px-2 py-1">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className={`px-3 py-[4px] rounded-md text-white text-sm 
            ${
              currentPage === 1
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#1d2951]"
            }`}
        >
          Prev
        </button>
   <span className="text-sm text-[#667085]">
         {currentPage} of {totalPages || 1}
      </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages || totalPages === 0}
          className={`px-3 py-[4px] rounded-md text-white text-sm
            ${
              currentPage === totalPages || totalPages === 0
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#1d2951]"
            }`}
        >
          Next
        </button>
      </div>

    </div>
  </>
)}

        </div>

        {/* RIGHT: detail view */}
        <div className="flex-1 min-w-0  bg-white flex flex-col">
          {/* Header */}
        

          {/* Body - Scrollable */}
          <div className="flex-1 min-h-0 overflow-y-auto ">
            <div className="space-y-4">
              {selectedVoicemail ? (
                <>
                  {/* ✅ Custom Audio Player (uses audioUrl) */}
                  <div className="bg-[#F3F4F6] rounded-lg border p-4">
                    
                    <audio
                      ref={audioRef}
                      src={audioUrl || undefined}
                      onLoadedMetadata={onLoadedMetadata}
                      onTimeUpdate={onTimeUpdate}
                      onPlay={() => setIsPlaying(true)}
                      onPause={() => setIsPlaying(false)}
                      onEnded={onEnded}
                      preload="metadata"
                      style={{ display: "none" }}
                    />

                    <div className="flex items-center gap-4">
                      <button
                        disabled={!audioUrl}
                        onClick={togglePlay}
                        className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center focus:outline-none
              bg-white text-black shadow-[0_6px_18px_rgba(0,0,0,0.12)]
               active:scale-[0.98]
              transition ${audioUrl ? "" : "opacity-50 cursor-not-allowed"}`}
                        title={
                          audioUrl ? (isPlaying ? "Pause" : "Play") : "No audio"
                        }
                      >
                        {isPlaying ? <OutlinePauseIcon /> : <OutlinePlayIcon />}
                      </button>
<div className="w-[250px] flex flex-col gap-1">
  <div className="flex  justify-between text-sm text-gray-500">
                          <span>{formatTime(currentTime || 0)}</span>
                          </div>
                {/* progress bar */}
                        <div
                          className={`w-full rounded-full h-2 mb-2 ${
                            audioUrl
                              ? "bg-gray-200 cursor-pointer"
                              : "bg-gray-100 cursor-not-allowed"
                          }`}
                          onClick={audioUrl ? seekToClick : undefined}
                        >
                          <div
                            className="bg-[#50869A] h-2 rounded-full transition-all"
                            style={{ width: `${progressPct || 0}%` }}
                          />
                        </div>           
</div>
                      <div className="flex-1">
                       

                        {/* <div className="flex justify-between text-sm text-gray-500">
                          <span>{formatTime(currentTime || 0)}</span>
                          <span>{formatTime(duration || 0)}</span>
                        </div> */}
                      </div>
                      <div className="flex gap-8 items-center">
                        

<div className="flex gap-2 text-[#7E7E7E]">
    <span className="mb-4">{formatTime(duration || 0)}</span>
              <button
  disabled={!audioUrl}
  onClick={() => {
    if (!audioRef.current) return;
    const newMuteState = !isMuted;
    audioRef.current.muted = newMuteState;
    setIsMuted(newMuteState);
  }}
  className={`text-gray-500 hover:text-gray-700 ${
    audioUrl ? "" : "opacity-50 cursor-not-allowed"
  }`}
  title={isMuted ? "Unmute" : "Mute"}
>
  {!isMuted ? (

    <VolumeUpIcon className="text-[#7E7E7E]" />
  ) : (

<VolumeOffIcon className="text-[#7E7E7E]"/>
  )} 
</button>
</div>
<div>
  {menu}
</div>
                      </div>

        

                    </div>
                  </div>

                  <div className="bg-white rounded-xl border border-[#E5E7EB] p-6">
                    <h3 className="text-[15px] text-left font-inter font-medium text-[#232323] mb-4">
                      Caller Information
                    </h3>

                    <div className="flex flex-col gap-y-6 text-sm">
                      <div className="grid grid-cols-2 gap-8 w-full">
                        <div>
                          <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                            Name:
                          </span>
                          <div className="font-medium text-left text-[#111827]">
                            {selectedVoicemail?.from?.name || "-"}
                          </div>
                        </div>

                        <div>
                          <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                            Phone:
                          </span>
                          <div className="font-medium text-left text-[#111827]">
                            {selectedVoicemail?.from?.phoneNumber || "-"}
                          </div>
                        </div>
                      </div>

                      {/* Row 2 */}
                      <div className="grid grid-cols-2 gap-8 w-full">
                        <div>
                          <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                            Date & Time:
                          </span>
                          <div className="font-medium text-left text-[#111827]">
                            {formatDate(selectedVoicemail?.creationTime) || "-"}
                          </div>
                        </div>

                        <div>
                          <span className="text-[#7E7E7E] text-sm font-medium font-inter text-left block mb-1">
                            Duration:
                          </span>
                          <div className="font-medium text-left text-[#111827]">
                            {formatTime(duration || 0) || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="bg-green-50 rounded-xl border-[1px] border-[#B9F8CF] px-3 py-3">
                    <h3 className="text-base font-inter font-medium text-left text-[#232323] mb-2 ml-2">
                      Read Status
                    </h3>

                    <div className="flex items-center justify-start gap-3">
                      <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-inter font-medium text-[#00A63E] bg-[#DCFCE7]">
                        TP
                      </div>
                      <div>
                        <div className="text-xs font-inter font-medium text-left text-[#232323]">
                          Read by: Teja P
                        </div>
                        <div className="text-[10px] font-inter font-normal text-left text-[#7E7E7E]">
                          Medical Assistant
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg border border-[#E5E7EB] p-3">
                    <h3 className="text-base font-inter font-medium text-left text-[#232323] mb-3">
                 Transcription
                    </h3>
                    <div className="text-xs font-inter font-normal text-[#232323] bg-[#FAF5FF] p-2 rounded-lg">
                      -
                    </div>
                  </div> */}
                </>
              ) : (
                <div className="h-full w-full flex items-center justify-center text-[#98A2B3]">
                  Select a voicemail from the list to view details.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>  
      </div>
      
<VoiceMailViewModal
  open={viewModalOpen}
  onClose={() => setViewModalOpen(false)}
  voicemail={selectedVoicemail}
  formatDate={formatDate}
  formatTime={formatTime}
/>

      {/* Loading Spinner */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Delete Confirmation Modal */}
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ${
          deleteModalOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          onClick={closeDeleteModal}
        ></div>
        <div className="relative bg-white text-start rounded-lg shadow-xl w-full max-w-md mx-4 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Confirm Delete
          </h2>
          <div className="mb-6">
            <p className="text-gray-600">
              Are you sure you want to delete this voicemail? This action cannot
              be undone.
            </p>
          </div>
          <div className="flex justify-end gap-3">
            <button
              onClick={closeDeleteModal}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
              autoFocus
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VoiceMailTable;
